import { dispatch } from "d3";
import { jobModified } from "./index";
import Notify from "./notifyActions";
export const GET_TREEVIEW = "GET_TREEVIEW";
export const JOB_ORDER_CHANGE = "JOB_ORDER_CHANGE";
export const POST_TREEVIEW_CHANGE = "POST_TREEVIEW_CHANGE";
export const POST_TREEVIEW_SET_PATH = "POST_TREEVIEW_SET_PATH";
export const TREEVIEW_TESTS_MOVE = "TREEVIEW_TESTS_MOVE";
export const NEW_TREEVIEW_NODE = "NEW_TREEVIEW_NODE";
export const REMOVE_TREEVIEW_NODE = "REMOVE_TREEVIEW_NODE";
export const NODE_EXPANDED = "NODE_EXPANDED";
export const NODE_INCLUDELOWERRECORDS = "NODE_INCLUDELOWERRECORDS";
export const NODE_RENAMED = "NODE_RENAMED";
export const NODE_MOVED_TO_VAULT = "NODE_MOVED_TO_VAULT";
export const NODE_MOVED = "NODE_MOVED";
export const GET_NODE_NOTE = "GET_NODE_NOTE";
export const ADD_NODE_NOTE = "ADD_NODE_NOTE";
export const TREEVIEW_NODE_NAME = "TREEVIEW_NODE_NAME";
export const LOWER_RECORDS_CHECKED = "LOWER_RECORDS_CHECKED";
export const SET_SELECTED_NODE = "SET_SELECTED_NODE";
export const SET_NODE_IDS = "SET_NODE_IDS";
export const TREEVIEW_EDIT_JOB_SET = "TREEVIEW_EDIT_JOB_SET";
export const TREEVIEW_EDIT_JOB_RESET = "TREEVIEW_EDIT_JOB_RESET";
export const SET_JOBS_TABLE_CHANGED = "SET_JOBS_TABLE_CHANGED";
export const SET_MONITORING_JOBS_TABLE_CHANGE = "SET_MONITORING_JOBS_TABLE_CHANGE";

export const treeviewNotifyError = (message) => {
  return (dispatch) => {
    dispatch(Notify.error(message));
  }
};

export const treeview = (selectedNodeId, selectedCustomerId, field, sorttype) => ({
  type: GET_TREEVIEW,
  payload: {
    request: {
      mode: "no-cors",
      url: `Treeview?selectedNodeId=${selectedNodeId}&selectedCustomerId=${selectedCustomerId}`,
      method: "GET"
    }
  }
});

export const jobOrderChange = (field, sorttype, selectedNodeId, selectedCustomerId) => ({
  type: JOB_ORDER_CHANGE,
  payload: {
    request: {
      mode: "no-cors",
      url: `JobOrderChange?field=${field}&sorttype=${sorttype}&selectedNodeId=${selectedNodeId}&selectedCustomerId=${selectedCustomerId}`,
      method: "GET"
    }
  }
});

export const treeviewChange = (treeviewState) => ({
  type: POST_TREEVIEW_CHANGE,
  data: treeviewState
});

export const moveTestInTree = (jobId, newNodeData, destinationId) => {
  return (dispatch) => {
    dispatch({
      type: TREEVIEW_TESTS_MOVE,
      payload: {
      request: {
          mode: "no-cors",
          url: `Treeview`,
          method: "POST",
          data: {jobId: jobId, nodes: newNodeData, destinationId: destinationId}
        }
      }
    }).then(response => { 
      if (response.payload.data.success === false) {
        dispatch(Notify.error("test_duplicate_error"));
        dispatch(treeview(-1));
      }
      else {
        dispatch(jobModified(jobId));
      }
    });
  };
};

export const nodeMoved = (nodeId, destinationNodeId, jobId, destinationJobId, selectedNodeId) => {
  return (dispatch) => {
    dispatch({type: NODE_MOVED,
    payload: {
    request: {
      mode: "no-cors",
      url: `Treeview/NodeMoved`,
      method: "POST",
      data: {NodeId: nodeId, DestinationNodeId: destinationNodeId, JobId: jobId, DestinationJobId: destinationJobId}
    }
  }
  }).then(response => {
    if (response.payload.data.success === false) {
      dispatch(Notify.error("test_duplicate_error"));
      dispatch(treeview(-1));
    }
    else {
      if (selectedNodeId == nodeId && jobId != destinationJobId) {
        dispatch(setNodeIds(''));
      }
      dispatch(jobModified(jobId));
      if (jobId != destinationJobId) {
        dispatch(jobModified(destinationJobId));
      }
    }
  });
};
};

export const treeviewNewNode = (parentId, title, type, jobId, selectedNodeId) => {
  return (dispatch) => {
    dispatch({
      type: NEW_TREEVIEW_NODE,
        payload: {
          request: {
            mode: "no-cors",
            url: `Treeview`,
            method: "PUT",
            data: {parentId: parentId, title: title, type: type, jobId: jobId}
    }
  }
    }).then(response => {
      dispatch(treeview(selectedNodeId));
    });
  };
};

export const treeviewRemoveNode = (id, jobId, deleteJob) => {
  return (dispatch) => {
    dispatch({type: REMOVE_TREEVIEW_NODE,
    payload: {
      request: {
        mode: "no-cors",
        url: `Treeview/node/${id}/${jobId}/${deleteJob}`,
        method: "DELETE"
    }
  }
  }).then(response => {
    if (deleteJob) {
      if (response.payload.data.success === true) {
        dispatch(Notify.success("job_delete_successfull_toast"));
      }
    }
    dispatch(treeview(-1));
  });
};
};

export const nodeExpanded = (id, isExpanded) => ({
  type: NODE_EXPANDED,
  payload: {
    request: {
      mode: "no-cors",
      url: `Treeview/ExpandedState`,
      method: "POST",
      data: {Id: id, IsExpanded: isExpanded}
    }
  }
});

export const nodeIncludeLowerRecords = (id, includeLowerRecords) => ({
  type: NODE_INCLUDELOWERRECORDS,
  payload: {
    request: {
      mode: "no-cors",
      url: `Treeview/IncludeLowerRecords`,
      method: "POST",
      data: {Id: id, IncludeLowerRecords: includeLowerRecords}
    }
  }
});

export const nodeRenamed = (nodeId, jobId, type, title) => {
  return (dispatch) => {
    dispatch({type: NODE_RENAMED,
    payload: {
    request: {
      mode: "no-cors",
      url: `Treeview/NodeRenamed`,
      method: "POST",
      data: {NodeId: nodeId, JobId: jobId, NewName: title, IsJobName: type === "job"}
    }
  }
  }).then(response => {
    if (response.payload.data.success === false) {
      dispatch(Notify.error("job_duplicate_error"));
      dispatch(treeview(-1));
    }
  });
};
};

export const nodeMovedToVault = (jobId, nodeId, isInVault) => ({
  type: NODE_MOVED_TO_VAULT,
  payload: {
    request: {
      mode: "no-cors",
      url: `Treeview/NodeMovedToVault`,
      method: "POST",
      data: {JobId: jobId, NodeId: nodeId, IsInVault: isInVault}
    }
  }
});

export const getNodeNote = (nodeId) => ({
  type: GET_NODE_NOTE,
  payload: {
    request: {
      mode: "no-cors",
      url: `Treeview/Note?nodeId=${nodeId}`,
      method: "GET"
    }
  }
});

export const addNodeNote = (nodeId, notes) => ({
  type: ADD_NODE_NOTE,
  payload: {
    request: {
      mode: "no-cors",
      url: `Treeview/Notes`,
      method: "POST",
      data: {NodeId: nodeId, Notes: notes}
    }
  }
});
 
export const lowerRecordsChecked = (checked) => ({
  type: LOWER_RECORDS_CHECKED,
  payload: {
    data: { checked: checked }
  }
});

export const setSelectedNode = (nodeId) => ({
  type: SET_SELECTED_NODE,
  payload: {
    request: {
      mode: "no-cors",
      url: `Treeview/SetSelectedNode`,
      method: "POST",
      data: {Id: nodeId}
    }
  }
});

export const setNodeIds = (nodeIds) => ({
  type: SET_NODE_IDS,
  payload: {
    data: { nodeIds }
  }
});

export const treeviewEditJobSet = (jobId) => ({
  type: TREEVIEW_EDIT_JOB_SET,
  payload: {
    data: { jobId }
  }
});

export const treeviewEditJobReset = (jobId) => ({
  type: TREEVIEW_EDIT_JOB_RESET
});

export const setJobsTableChanged = (jobsTableChanged) => ({
  type: SET_JOBS_TABLE_CHANGED,
  payload: {
    data: { jobsTableChanged }
  }
});

export const setMonitoringJobsTableChange = (monitoringJobsTableChange) => ({
  type: SET_MONITORING_JOBS_TABLE_CHANGE,
  payload: {
    data: { monitoringJobsTableChange }
  }
});
